import { FC, useEffect, useState } from 'react';
import { AssetTypeContext } from './AssetTypeContext';
import { IAvailableAssetTypes } from '@brickwise/asset-validation/dist/utils';
import { useAsset } from '../AssetContext';
import { Outlet, useLocation } from 'react-router';
import { Routes as RoutesData } from '../../router/Routes';
import { useUser } from 'src/hooks/useUser';

const AssetTypeProvider: FC = () => {
  const [assetType, setAssetType] = useState('realEstate' as IAvailableAssetTypes);

  const currentPage = useLocation();
  const user = useUser();

  const { asset: currentAsset } = useAsset();

  useEffect(() => {
    if (currentPage.pathname.includes(RoutesData.ASSETS.ADD)) {
      if (user?.partner?.assetType) {
        setAssetType(user.partner.assetType[0]);
        return;
      }
    }

    if (currentAsset.type) {
      setAssetType(currentAsset.type);
      return;
    }
  }, [currentAsset, currentPage, user]);

  return (
    <AssetTypeContext.Provider value={{ assetType, setAssetType }}>
      <Outlet />
    </AssetTypeContext.Provider>
  );
};

export default AssetTypeProvider;
